export const site = {
  name: "Paul's Pens n Things",
  maker: "Paul Sherman",
  email: "paul@paulspensnthings.com",
  phoneDisplay: "(870) 273-2140",
  phoneHref: "+18702732140",
  city: "Paragould",
  state: "Arkansas",
  region: "AR",
  locality: "Paragould, Arkansas",
  domain: "https://paulspensnthings.com",
  latheSince: 2006,
  cncSince: 2019,
  announcement: "Handcrafted in Paragould, Arkansas, since 2006",
  tagline: "Handcrafted pieces made around your story.",
} as const;

/** Absolute URL for canonical / Open Graph tags (Lighthouse rejects a bare `/`). */
export function pageUrl(path: string): string {
  const url = /^https?:\/\//i.test(path) ? new URL(path) : new URL(path, `${site.domain}/`);
  if (url.origin !== new URL(site.domain).origin) {
    throw new Error(`pageUrl refused off-origin path: ${path}`);
  }
  return url.href;
}

export type NavLink = { label: string; to: string; description?: string };

export const primaryNav: NavLink[] = [
  { label: "Home", to: "/" },
  { label: "Pens and Pencils", to: "/custom-pens" },
  { label: "Other Things", to: "/other-creations" },
  { label: "Cornhole Boards", to: "/cornhole-boards" },
  { label: "Contact", to: "/contact" },
];

export const pensAndPencilsMenu: NavLink[] = [
  { label: "Fountain/Rollerball Pens", to: "/gallery?category=pens&subcategory=fountain-rollerball" },
  { label: "Bolt-action pens", to: "/gallery?category=pens&subcategory=bolt-action" },
  { label: "Rifle Cartridge Pens", to: "/gallery?category=pens&subcategory=rifle-cartridge" },
  { label: "Designer pens", to: "/gallery?category=pens&subcategory=designer" },
  { label: "Sierra Mesa Gatsby pens", to: "/gallery?category=pens&subcategory=sierra-mesa-gatsby" },
  { label: "Other Ballpoint Pens", to: "/gallery?category=pens&subcategory=other-ballpoint" },
  { label: "Pen and Pencil Combo/Sets", to: "/gallery?category=pens&subcategory=pen-pencil-sets" },
  { label: "Pencils", to: "/gallery?category=pens&subcategory=pencils" },
  { label: "Cigar style pens", to: "/gallery?category=pens&subcategory=cigar-style" },
];

export const otherThingsMenu: NavLink[] = [
  { label: "Other Lathe Items", to: "/gallery?category=other-things&subcategory=other-lathe-items" },
  { label: "Signs", to: "/gallery?category=other-things&subcategory=signs" },
  { label: "Fidget Spinners", to: "/gallery?category=other-things&subcategory=fidget-spinners" },
  { label: "3D Carvings", to: "/gallery?category=other-things&subcategory=3d-carvings" },
  { label: "Other CNC Items", to: "/gallery?category=other-things&subcategory=other-cnc-items" },
  { label: "Miscellaneous Items", to: "/gallery?category=other-things&subcategory=miscellaneous-items" },
];


export const penTurnersMenu: NavLink[] = [
  {
    label: "Downloads",
    to: "/downloads",
    description: "Reference sheets and templates from the shop",
  },
  {
    label: "Fordite and Colorwood",
    to: "/fordite-and-colorwood",
    description: "Layered paint slag and laminated colorwood blanks",
  },
  {
    label: ".30 and .50 Cal Components",
    to: "/cal-components",
    description: "Cartridge cases and matching hardware",
  },
  {
    label: "Tube-On Clear-Cast Blanks",
    to: "/tube-on-clear-cast-blanks",
    description: "Cast on the tube — no drilling, nothing shifts",
  },
  {
    label: "Embedded Object Blanks",
    to: "/embedded-object-blanks",
    description: "Your object, cast and ready to turn",
  },
  {
    label: "Bottle Stopper Blanks",
    to: "/bottle-stopper-blanks",
    description: "Roses and fishing flies cast over a color base",
  },
];


export const footerCategories: NavLink[] = [
  { label: "Pens and Pencils", to: "/custom-pens" },
  { label: "Lathe-Turned Gifts", to: "/lathe-turned-gifts" },
  { label: "CNC & Engraved", to: "/cnc-engraved" },
  { label: "Other Creations", to: "/other-creations" },
  { label: "For Pen Turners", to: "/for-pen-turners" },
  { label: "All Creations", to: "/gallery" },
];

export const footerCompany: NavLink[] = [
  { label: "About Paul", to: "/about" },
  { label: "Design Your Piece", to: "/design-your-piece" },
  { label: "Contact", to: "/contact" },
  { label: "FAQ", to: "/faq" },
];

export const footerLegal: NavLink[] = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
  { label: "Accessibility", to: "/accessibility" },
];
